import { useOutletContext } from 'react-router-dom'
import { Local } from 'service/api'

export function useLocaisOutletContext() {
    return useOutletContext<{
        data?: Local[]
    }>()
}
